import { render, staticRenderFns } from "./tourist.vue?vue&type=template&id=4f63f9c2&scoped=true&"
import script from "./tourist.vue?vue&type=script&lang=js&"
export * from "./tourist.vue?vue&type=script&lang=js&"
import style0 from "./tourist.vue?vue&type=style&index=0&id=4f63f9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63f9c2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/chofn/components/Header.vue').default})
